import React from 'react'
import { Route, Routes} from 'react-router-dom';
import Profile from './Profile';
import ChangePass from './ChangePass';
import Company from './company/Company';
import HotKeys from './HotKeys';

export default function SettingRoute() {
  return (
     <Routes>
          <Route path="/profile" element={<Profile />} />
          <Route path="/changePass" element={<ChangePass />} />
          <Route path="/companyDetails" element={<Company />} />
          <Route path="/shortKeys" element={<HotKeys />} />
     </Routes>
  )
}
